type ThumbsUpProps = {
  className?: string;
  color?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const ThumbsUp = ({
  className,
  color,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: ThumbsUpProps) => {
  return (
    <svg
      className={`${className}`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-tooltip-id="thumbs-up-tooltip"
      viewBox="0 0 12 11"
      xmlns="http://www.w3.org/2000/svg"
      fill={color || "currentColor"}
    >
      <path
        fillRule={`${color ? "nonzero" : "evenodd"}`}
        clipRule="evenodd"
        d="M8.02602 0.774846C8.0797 0.925063 8.08705 1.08758 8.04715 1.24191L7.41824 3.6774H10.9091C11.1985 3.6774 11.476 3.79069 11.6805 3.99234C11.8851 4.194 12.0001 4.4675 12.0001 4.75268V5.88386C12.0002 6.02438 11.9724 6.16356 11.9182 6.29354L10.2301 10.3339C10.1889 10.4324 10.1189 10.5166 10.0291 10.5759C9.93927 10.6351 9.8336 10.6667 9.72551 10.6667H3.81824C3.67358 10.6667 3.53484 10.61 3.43255 10.5092C3.33025 10.4084 3.27279 10.2716 3.27279 10.129V3.89998C3.27282 3.75741 3.3303 3.62068 3.4326 3.51988L6.92351 0.0790084C6.96991 0.0331448 7.03155 0.00533446 7.09709 0.000691859C7.16263 -0.00395074 7.22767 0.0148866 7.28024 0.0537395L7.74551 0.397826C7.87473 0.493442 7.97234 0.624629 8.02602 0.774846ZM10.8667 4.81074V5.87047L9.33626 9.53333H4.40612V4.15165L6.71223 1.87859L5.95507 4.81074H10.8667Z"
      />
      <path d="M2.18182 4.21505H0.545455C0.400791 4.21505 0.262052 4.27169 0.15976 4.37252C0.0574673 4.47334 0 4.61009 0 4.75268V10.129C0 10.2716 0.0574673 10.4084 0.15976 10.5092C0.262052 10.61 0.400791 10.6667 0.545455 10.6667H2.18182V4.21505Z" />
    </svg>
  );
};

export default ThumbsUp;
